// Returns a function, that, as long as it continues to be invoked, will only
// be triggered every N milliseconds.

// https://codeburst.io/throttling-and-debouncing-in-javascript-b01cad5c8edf

// throttle :: Function, Number -> (Any -> Void)
export function throttle(func, limit) {
	let lastFunc;
	let lastRan;
	return function throttled(...args) {
		const context = this;
		if (!lastRan) {
			func.apply(context, args);
			lastRan = Date.now();
		} else {
			clearTimeout(lastFunc);
			lastFunc = setTimeout(() => {
				if ((Date.now() - lastRan) >= limit) {
					func.apply(context, args);
					lastRan = Date.now();
				}
			}, limit - (Date.now() - lastRan));
		}
	};
}
